import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';
import { ApiResponseServerDto } from '@app/shared/models/api-response.dtos';
import { guiActions } from '@app/store/gui/actions/gui.actions';
import { SKIP_ERROR_HANDLER } from '../http-context';

export const apiErrorInterceptor: HttpInterceptorFn = (request, next) => {
    if (request.context.get(SKIP_ERROR_HANDLER)) {
        return next(request);
    }
    const store = inject(Store);
    const translateService = inject(TranslateService);
    return next(request).pipe(
        catchError((response: HttpErrorResponse) => {
            errorCodes(response, store, translateService);
            return throwError(() => response);
        }),
    );
};

function errorCodes(response: HttpErrorResponse, store: Store, translateService: TranslateService): void {
    const apiResponse = <ApiResponseServerDto>response.error;
    const errors = apiResponse?.errors;
    const data = apiResponse?.data;

    switch (response.status) {
        case 0:
            store.dispatch(
                guiActions.showErrorToast({
                    options: {
                        summary: <string>translateService.instant('GUI.ERRORS.error_occurred'),
                        detail: <string>translateService.instant('GUI.ERRORS.try_again_later'),
                    },
                }),
            );
            break;
        case 401:
            // Refresh Token Interceptor handles this
            break;
        default: {
            if (errors && errors[0].title) {
                store.dispatch(
                    guiActions.showErrorToast({
                        options: {
                            summary: errors[0].title,
                            detail: data?.details,
                            life: data?.time || errors[0].life,
                        },
                    }),
                );
            } else {
                store.dispatch(
                    guiActions.showErrorToast({
                        options: { summary: <string>translateService.instant('FORMS.ERRORS.Http_general') },
                    }),
                );
            }
            break;
        }
    }
}
